// src/ProjectForm.js
import React, { useState } from 'react';
import axios from 'axios';
import { Navigate, useNavigate } from 'react-router-dom';
import Particle from '../Particle';

function ProjectForm() {
  const [project, setProject] = useState({
    imgPath: '',
    isBlog: false,
    title: '',
    description: '',
    ghLink: '',
    demoLink: ''
  });

  const Navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setProject((prevProject) => ({
      ...prevProject,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    setProject({
      imgPath: '',
      isBlog: false,
      title: '',
      description: '',
      ghLink: '',
      demoLink: ''
    });

    axios.post('https://portfolio-server-91pj.onrender.com/addproject',project, {
      headers: {
        Authorization: `Bearer `+localStorage.getItem("Token")
      }
    })


    Navigate('/');
  };

  return (
    <form className="project-form" onSubmit={handleSubmit}>
    <h2>Add New Project</h2>
      <div className="form-group">
        <label>Image Path</label>
        <input type="text" name="imgPath" value={project.imgPath} onChange={handleChange} required />
      </div>
      <div className="form-group">
        <label>
          <input type="checkbox" name="isBlog" checked={project.isBlog} onChange={handleChange} />
          Is Blog
        </label>
      </div>
      <div className="form-group">
        <label>Title</label>
        <input type="text" name="title" value={project.title} onChange={handleChange} required />
      </div>
      <div className="form-group">
        <label>Description</label>
        <textarea name="description" value={project.description} onChange={handleChange} required />
      </div>
      <div className="form-group">
        <label>GitHub Link</label>
        <input type="url" name="ghLink" value={project.ghLink} onChange={handleChange} />
      </div>
      <div className="form-group">
        <label>Demo Link</label>
        <input type="url" name="demoLink" value={project.demoLink} onChange={handleChange} />
      </div>
      <button type="submit">Add Project</button>
    </form>
  );
}

export default ProjectForm;
